import Sidebar from "../../components/Sidebar";
import MyPageHeader from "../../components/Header/MyPageHeader";
import React from "react";

const MySendPageGiftPage = () => {


  return (
      <div>
        <Sidebar/>
        <div className="lg:pl-64">
          <MyPageHeader/>
          <main>
            <div className="lg:mt-16 sm:mx-4 h-full lg:px-52 border-t border-white/10 py-6 sm:py-16">
              내 팡 선물 하기

            </div>
          </main>
        </div>
      </div>
  )
}
export default MySendPageGiftPage;